import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@one-thd/sui-atomic-components';
import { Search } from '@one-thd/sui-icons';
import { TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const ProjectSearch = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const hasTriggeredAnalytics = useRef(false);
  const debounceTimer = useRef(null);
  const pendingAnalytics = useRef(false);

  useEffect(() => {
    return () => {
      clearTimeout(debounceTimer.current);
      if (pendingAnalytics.current) {
        triggerAnalytics(TRACK.PROJECT_OVERLAY_SEARCH);
      }
    };
  }, []);

  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    onSearch(term);

    clearTimeout(debounceTimer.current);
    if (term.length > 0 && !hasTriggeredAnalytics.current) {
      pendingAnalytics.current = true;
      debounceTimer.current = setTimeout(() => {
        hasTriggeredAnalytics.current = true;
        pendingAnalytics.current = false;
        triggerAnalytics(TRACK.PROJECT_OVERLAY_SEARCH);
      }, 300);
    }
    if (term.length === 0) {
      hasTriggeredAnalytics.current = false;
    }
  };

  return (
    <div className="sui-my-6 sui-pr-4">
      <TextField
        fullWidth
        placeholder="Search Project Names"
        value={searchTerm}
        onChange={handleSearch}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search size="small" />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

ProjectSearch.propTypes = {
  onSearch: PropTypes.func.isRequired
};
